import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";
import { IconClock } from "./Icons";

const WorkingHours = () => {
    const { t } = useLanguage();
    const cards = [
        { id: "women", label: t.hours.women, time: t.hours.womenTime },
        { id: "men", label: t.hours.men, time: t.hours.menTime },
    ];    return (
        <section id="hours" className="scroll-mt-24 bg-tint/60 py-12 md:py-20" aria-labelledby="hours-title" data-testid="hours-section">
            <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <Overline>{t.hours.overline}</Overline>
                    <h2 id="hours-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        {t.hours.title}
                    </h2>
                </Reveal>
                <div className="mt-12 grid gap-4 sm:grid-cols-2 md:gap-6">
                    {cards.map((c, i) => (
                        <Reveal key={c.id} delay={i * 0.08}>
                            <div
                                data-testid={`hours-card-${c.id}`}
                                className="relative overflow-hidden rounded-2xl border border-ink/10 bg-surface p-7 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_24px_45px_-25px_rgba(0,77,77,0.4)] md:p-9"
                            >
                                <span aria-hidden="true" className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-gold-500 via-gold-500/60 to-transparent" />
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold-100 text-gold-600">
                                    <IconClock />
                                </span>
                                <h3 className="mt-5 text-lg font-semibold text-ink">{c.label}</h3>
                                <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-gold-600">{t.hours.days}</p>
                                <p className="mt-2 font-display text-2xl text-pine md:text-3xl">
                                    {c.time}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.12}>
                    <p
                        data-testid="hours-friday-closed"
                        className="mt-6 inline-flex items-center gap-2.5 rounded-full border border-ink/10 bg-surface px-5 py-2.5 text-sm font-semibold text-ink"
                    >
                        <span className="h-2 w-2 rounded-full bg-red-500" aria-hidden="true" />
                        {t.hours.closed}
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="mt-5 text-sm leading-relaxed text-mist md:text-base">{t.hours.note}</p>
                </Reveal>
            </div>
        </section>
    );
};

export default WorkingHours;
